import React from 'react';

interface AppShellProps {
  children: React.ReactNode;
  className?: string;
  layoutId?: string;
  footerHeight?: number;
}

export function AppShell({ children, className = '', layoutId, footerHeight }: AppShellProps) {
  return (
    <div
      className={`app-shell min-h-screen bg-(--color-bg) flex flex-col text-(--color-text) ${className}`.trim()}
      style={typeof footerHeight === 'number' ? ({ '--footer-height': `${footerHeight}px` } as React.CSSProperties) : undefined}
      data-layout-id={layoutId}
    >
      <div className="flex-1 min-h-0 relative">
        {children}
      </div>
    </div>
  );
}
